export default __webpack_public_path__ + "static/media/logo-bg-new-post.c193ac1c.png";